/** @jsx jsx */
import { jsx } from 'theme-ui';
import { Fragment } from 'react';
import { InlineAddress } from './InlineAddress';
import { CountryDisplay } from './CountryDisplay';
export var AddressDisplay = function (_a) {
    var className = _a.className, address = _a.address, inline = _a.inline;
    return address ? (jsx("div", { className: className }, inline ? (jsx(InlineAddress, { address: address })) : (jsx(Fragment, null,
        jsx("div", null, address.line1),
        address.line2 && jsx("div", null, address.line2),
        address.town && jsx("div", null, address.town),
        jsx("div", null, address.postcode),
        address.countryCode && jsx(CountryDisplay, { code: address.countryCode }))))) : null;
};
//# sourceMappingURL=AddressDisplay.js.map